import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { BuyerListQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

// ---------------------------------------------------------------------------
// GQL document
// ---------------------------------------------------------------------------

const buyerListQuery = graphql(`
  query buyerList($id: String!) {
    buyerList(id: $id) {
      id
      name
      sharingType
      ownerId
      companyId
      createdAt
      updatedAt
      isDeleted
      entries {
        id
      }
      permissionActions
    }
  }
`);

// ---------------------------------------------------------------------------
// Exported type
// ---------------------------------------------------------------------------

/** A single buyer list as returned by the GQL query (replaces BuyerListDto). */
export type BuyerListDetail = BuyerListQuery["buyerList"];

// ---------------------------------------------------------------------------
// useBuyerList
// ---------------------------------------------------------------------------

export function useBuyerList(
  id: string,
  options?: UseQueryOptions<BuyerListQuery, unknown, BuyerListQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["buyerList", id], buyerListQuery, [{ id }], options);
  return { data: data?.buyerList, ...rest };
}
